export enum PurposeAndStatusRedirectStepEnum {
  PurposeOfTrading = 1,
  EmploymentStatus,
  AmountToInvest,
  SourceOfFund,
  AnnualNetIncome,
  EstimatedNetWorth,
}
